export const getAccessToken = () => localStorage.getItem('access_token');
